import { Component } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../../../account/account.service";
import {DepositService} from "../deposit.service";
import {DepositModel, DepositPersonModel} from "../deposit.model";
import {AuthService} from "../../../../shared/services/auth.service";
import { ToastrService } from 'ngx-toastr';
import { cpf, cnpj } from 'cpf-cnpj-validator';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss']
})
export class DepositComponent {
  deposito = new FormGroup({
    documento: new FormControl<string>('',[Validators.required]),
    nome: new FormControl<string>('',Validators.required),
    valor: new FormControl<number | null>(null,[Validators.required, Validators.min(1)]),
    taxa: new FormControl<number>(0),
    valorTotal: new FormControl<number>(0),
  });

  public isSubmitted:boolean;
  public documentFeedBack: string;
  public nomeFeedBack: string;
  public valorFeedBack: string;

  public depositTaxValue: number = 0;
  public depositTaxPercent: number = 0;

  public pixGenerated: boolean;
  public pixCopiaECola: string;
  public qrCodeBase64: string;

  public isLoaded: boolean;

  constructor(private accountService : AccountService,
              private depositService : DepositService,
              private authService: AuthService,
              private toastr: ToastrService) {
    this.getAccountValues();
    this.isSubmitted = false;
    this.documentFeedBack = '';
    this.nomeFeedBack = '';
    this.valorFeedBack = '';
    this.qrCodeBase64 = '';
    this.pixGenerated = false;
    this.pixCopiaECola = '';
    this.isLoaded = true;
  }

  public getAccountValues(){
    this.accountService.getAccount().then(
      value => {
        this.depositTaxValue = value.depositTaxValue;
        this.depositTaxPercent = value.depositTaxPercent;
      }
    );
  }

  public transformValue = (value: string | number | undefined | null): string => {
    return String(Number(value) / 100);
  };

  public valorChanged() {
    let valor = Number(this.deposito.controls.valor.value);
    this.deposito.controls.valor.setValue(valor)
    let taxa = ( valor * this.depositTaxPercent) / 100;
    taxa = valor > 0 ? (taxa + this.depositTaxValue) : 0;
    let valorTotal = valor > 0 ? (valor - taxa) : 0;
    this.deposito.controls.taxa.setValue(taxa);
    this.deposito.controls.valorTotal.setValue(valorTotal);
  }

  public makeDeposit(){
    this.isSubmitted = true;
    this.pixGenerated = false;
    this.isLoaded = false;
    this.qrCodeBase64 = '';

    if(!this.formIsValid())
    {
      this.isLoaded = true;
      return;
    }
    let depositModel = new DepositModel();
    depositModel.person = new DepositPersonModel()
    depositModel.person.cpf = this.deposito.controls.documento.value!;
    depositModel.person.name = this.deposito.controls.nome.value!;
    depositModel.value = this.deposito.controls.valor.value!;

    this.depositService.sendDeposit(depositModel).subscribe(
      next =>{
        this.pixCopiaECola = next.pixCopiaECola;
        this.qrCodeBase64 = `data:image/bmp;base64,${next.qrCodeBase64}`;
        this.pixGenerated = true;
        this.toastr.success(`Solicitação de depósito realizada com sucesso! Transação: ${next.id}`,'Sucesso',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.isLoaded = true;
      },
      error =>{
        this.toastr.error(error.error.mensagem,'Erro',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.isLoaded = true;
      }
    );
  }

  public formIsValid() : boolean{
    if(this.deposito.controls.documento.value!.length === 11 && !cpf.isValid(this.deposito.controls.documento.value!) ||
       this.deposito.controls.documento.value!.length === 14 && !cnpj.isValid(this.deposito.controls.documento.value!))
    {
      this.deposito.controls.documento.setErrors(Validators.required)
      this.documentFeedBack = 'Documento inválido!';
    }
    if(this.deposito.controls.documento.hasError('required')){
      this.documentFeedBack = 'Documento é obrigatório!';
    }
    if(this.deposito.controls.nome.invalid){
      this.nomeFeedBack = 'Nome é obrigatório!';
    }
    if(this.deposito.controls.valor.hasError('min')){
      this.valorFeedBack = 'Valor inválido - Valor mínimo R$ 1,00!';
    }else if(this.deposito.controls.valor.invalid){
      this.valorFeedBack = 'Valor é obrigatório!';
    }
    return this.deposito.valid;
  }
}
